import React, { useEffect } from 'react';
import { Form } from 'react-final-form';
import { useDispatch } from 'react-redux';

import PlaygroundForm from './components/PlaygroundForm';
import { getPlaygroundAssistants, playgroundRequest, resetSession } from '../redux/ai-playground/aiPlaygroundActions';
import ResponsesList from './components/ResponsesList';
import validate from '../utils/validate';
import { playgroundYopValidation } from './validation';
import CommonPage from '../components/common-page/CommonPage';
import { resetAIPlayground } from '../redux/ai-playground/aiPlaygroundReducer';

import scss from './AiPlayground.module.scss';

function AiPlayground() {
  const dispatch = useDispatch();

  const initialPlaygroundValues = {
    fileText: '',
    assistant: '',
    message: '',
  };

  const handleSubmitPlaygroundForm = (values, form) => {
    form.restart({ message: '', fileText: values.fileText, assistant: values.assistant });
    dispatch(playgroundRequest(values));
  };

  useEffect(() => {
    dispatch(getPlaygroundAssistants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleResetSession = () => {
      dispatch(resetSession());
      dispatch(resetAIPlayground());
    };

    window.addEventListener('beforeunload', handleResetSession);

    return () => {
      window.removeEventListener('beforeunload', handleResetSession);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      dispatch(resetSession());
      dispatch(resetAIPlayground());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CommonPage className={scss.wrapper}>
      <Form
        initialValues={initialPlaygroundValues}
        onSubmit={handleSubmitPlaygroundForm}
        validate={(values) => validate(values, playgroundYopValidation())}
        subscription={{ submitting: true, pristine: true }}
        validateOnBlur={false}
        render={({ handleSubmit }) => <PlaygroundForm onSubmit={handleSubmit} />}
      />

      <ResponsesList />
    </CommonPage>
  );
}

export default AiPlayground;
